import React from 'react';
import StyledButton from "../commons/StyledButton";
import { useAppDispatch } from "../../../../redux/hooks";
import { goHomeScreen } from "../../../../redux/features/verification/verification.slice";

// Import images
import winnerImg from "../../../../assets/winner.png";
import firstRunnerUpImg from "../../../../assets/firstrunnerup.png";
import secondRunnerImg from "../../../../assets/secondrunner.png";
import specialMentionImg from "../../../../assets/specialmention.png";
import globeImg from "../../../../assets/globe.png";

const placementMap: { [key: string]: string } = {
    "Participant": "CERTIFICATE OF PARTICIPATION",
    "Finale participants": "CERTIFICATE OF ACHIEVEMENT",
    "Winners": "CERTIFICATE OF ACHIEVEMENT",
    "1st Runner-up": "CERTIFICATE OF ACHIEVEMENT",
    "2nd Runner-up": "CERTIFICATE OF ACHIEVEMENT",
    "Special Mention (3rd Runner-up)": "CERTIFICATE OF ACHIEVEMENT"
    // Add more mappings as needed
};

const messageMap: { [key: string]: string } = {
    "Participant": `In recognition of your valuable participation in the <b>Infosys Global Hackathon 2025</b>, powered by <b>Infosys</b> along with <b>Cloud Native
Computing Foundation (CNCF).</b><br/><br/>

<b>Thank you for contributing your skills and creativity to build solutions for global good.</b>
`,
    "Finale participants": `In recognition of your valuable participation in the <b>Infosys Global Hackathon 2025</b>, powered by <b>Infosys</b> along with <b>Cloud Native
Computing Foundation (CNCF).</b><br/><br/>

<b>Thank you for contributing your skills and creativity to build solutions for global good.</b>
`,
    "Winners": `In recognition of your valuable participation in the <b>Infosys Global Hackathon 2025</b>, powered by <b>Infosys</b> along with <b>Cloud Native
Computing Foundation (CNCF).</b><br/><br/>

<b>Thank you for contributing your skills and creativity to build solutions for global good.</b>
`,
    "1st Runner-up": `In recognition of your valuable participation in the <b>Infosys Global Hackathon 2025</b>, powered by <b>Infosys</b> along with <b>Cloud Native
Computing Foundation (CNCF).</b><br/><br/>

<b>Thank you for contributing your skills and creativity to build solutions for global good.</b>
`,
    "2nd Runner-up": `In recognition of your valuable participation in the <b>Infosys Global Hackathon 2025</b>, powered by <b>Infosys</b> along with <b>Cloud Native
Computing Foundation (CNCF).</b><br/><br/>

<b>Thank you for contributing your skills and creativity to build solutions for global good.</b>
`,
    "Special Mention (3rd Runner-up)": `In recognition of your valuable participation in the <b>Infosys Global Hackathon 2025</b>, powered by <b>Infosys</b> along with <b>Cloud Native
Computing Foundation (CNCF).</b><br/><br/>

<b>Thank you for contributing your skills and creativity to build solutions for global good.</b>
`
    // Add more mappings as needed
};

// Image mapping based on placement
const imageMap: { [key: string]: string } = {
    "Winners": winnerImg,
    "1st Runner-up": firstRunnerUpImg,
    "2nd Runner-up": secondRunnerImg,
    "Special Mention (3rd Runner-up)": specialMentionImg,
    "Participant": globeImg,
    "Finale participants": globeImg
};

function VcDisplayCard({ vc }: { vc: any }) {
    const dispatch = useAppDispatch();

    // Extract fields
    const {
        participantName,
        teamName,
        projectName,
        hackathonName,
        hackathonDate,
        stage,
        placement
    } = vc?.credentialSubject || {};

    // Get the appropriate image for the placement
    const placementImage = globeImg;
    const bgImage = imageMap[placement || ""] || globeImg;

    return (
        <div className="flex flex-col items-center justify-center min-h-[500px] bg-white rounded-xl shadow-lg border border-[#e0e0e0] p-8 w-full max-w-[600px] mx-auto" >
            {/* Certificate Title */}
            <div className="text-center mb-4">
                {/* Placement Image */}
                <div className="mb-4">
                    <img
                        src={placementImage}
                        alt={placement || "Certificate"}
                        className="w-16 h-16 mx-auto object-contain"
                    />
                </div>
                <h3 className={` font-semibold text-xl mb-1 text-[#007cc3]`}>
                    {hackathonName || "Hackathon Name"}
                </h3>
                <h2
                    className={`font-bold text-2xl uppercase tracking-wide mb-2 ${placement === "Winners"
                        ? "text-[#6c276b]" // Gold for Winners
                        : placement === "1st Runner-up"
                            ? "text-[#6c276b]" // Silver for 1st Runner-up
                            : placement === "2nd Runner-up"
                                ? "text-[#6c276b]" // Bronze for 2nd Runner-up
                                : "text-[#007cc3]" // Default color
                        }`}
                >
                    {placement ? `${placementMap[placement] || placement}` : "Certificate of Participation"}
                </h2>

                <p className="text-gray-600 text-base mb-2">
                    {hackathonDate || "Hackathon Date"}
                </p>
            </div>

            {/* Presented to */}
            <div className="w-full text-center mb-6">
                <span className="block text-gray-500 text-sm mb-1">Presented to</span>
                <span className="block font-extrabold  text-3xl text-[#222] mb-2">
                    {participantName ? participantName.toUpperCase() : "PARTICIPANT NAME"}
                </span>
            </div>

            {/* Details */}
            <div
                className="w-full new-div grid grid-cols-2 gap-y-2 gap-x-6 mb-6 bg-contain bg-no-repeat absolute inset-0 opacity-15 bg-contain bg-center bg-no-repeat"
                style={{
                    backgroundImage: `url(${bgImage})`,
                    maxWidth: '250px',
                    margin: 'auto',
                }}
            ></div>
            <div
                className={`w-full grid grid-cols-2 gap-y-2 gap-x-6 mb-6 bg-cover bg-contain bg-no-repeat `}
            // style={{ backgroundImage: `url(${bgImage})` }}
            >
                <div className="text-right font-medium text-gray-700">Team Name:</div>
                <div className="text-left font-bold text-gray-900">{teamName || "-"}</div>
                <div className="text-right font-medium text-gray-700">Project Name:</div>
                <div className="text-left font-bold text-gray-900">{projectName || "-"}</div>
                <div className="text-right font-medium text-gray-700">Stage:</div>
                <div className="text-left font-bold text-gray-900">{stage || "-"}</div>
                <div className="text-right font-medium text-gray-700">Placement:</div>
                <div className="text-left font-bold text-gray-900">{placement || "-"}</div>
            </div>

            {/* Footer */}
            <div className="w-full flex flex-col items-center mt-4 mb-8">
                <p className="text-gray-600 text-sm mb-2">
                    {placement && messageMap[placement] ? (
                        <div
                            style={{ textAlign: "justify" }}
                            dangerouslySetInnerHTML={{ __html: messageMap[placement] }}
                        />
                    ) : ""}
                </p>
                {/* Signatures can be added here if needed */}
            </div>

            {/* Button */}
            <StyledButton
                id="verify-another-qr-code-button"
                className="mx-auto mt-6 mb-2 z-10"
                onClick={() => dispatch(goHomeScreen({}))}
            >
                Verify Another QR code
            </StyledButton>
        </div>
    );
}

export default VcDisplayCard;
